import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "d-flex flex-column align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", {
  style: {"text-align":"center"},
  class: "mb-4"
}, "We've updated our Terms of Service & Privacy Policy", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  style: {"text-align":"center"},
  class: "fs-4"
}, " Occasionally, StageHub will update its terms, in order to better support you, our users. Please be sure to review these updated documents. You will need to accept the changes in order to continue using StageHub. ", -1)
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label required",
  for: "tosCheckbox"
}, [
  /*#__PURE__*/_createTextVNode("Accept "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "fw-bolder link-primary",
    href: "http://g.stagehub.com/tos",
    target: "_blank"
  }, "Terms & Conditions")
], -1)
const _hoisted_9 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label required",
  for: "privacyCheckbox"
}, [
  /*#__PURE__*/_createTextVNode("Accept "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "fw-bolder link-primary",
    href: "http://g.stagehub.com/privacy",
    target: "_blank"
  }, "Privacy Policy")
], -1)
const _hoisted_12 = { class: "mb-6" }
const _hoisted_13 = { class: "form-check" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "subscribeCheckbox"
}, "Yes, keep me up-to-date on new features on StageHub!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.shouldAcceptTos)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.consent.acceptsTos) = $event)),
                  id: "tosCheckbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.consent.acceptsTos]
                ]),
                _hoisted_8
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.shouldAcceptPrivacyPolicy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.consent.acceptsPrivacyPolicy) = $event)),
                  id: "privacyCheckbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.consent.acceptsPrivacyPolicy]
                ]),
                _hoisted_11
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.consent.emailOptIn) = $event)),
              id: "subscribeCheckbox",
              checked: "checked"
            }, null, 512), [
              [_vModelCheckbox, _ctx.consent.emailOptIn]
            ]),
            _hoisted_14
          ])
        ])
      ]),
      _createVNode(_component_Button, {
        onClick: _ctx.submitUpdatedTerms,
        "is-disabled": !_ctx.isValid
      }, {
        default: _withCtx(() => [
          _createTextVNode("Save & Continue")
        ]),
        _: 1
      }, 8, ["onClick", "is-disabled"])
    ])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ]))
}